<template>
  <div class="form__group">
    <label
      class="form__label"
      :for="id"
    >{{ label }}</label>
    <select
      :id="id"
      :name="id"
      :disabled="disabled"
      v-bind="attr"
      class="form__control"
      @change="optionChanged()"
    >
      <option
        v-if="defaultSelected"
        disabled
        selected
        value=""
      >
        {{ $t('misc.forms.selectDefault') }}
      </option>
      <option
        v-for="(option, index) in options"
        :key="index"
        :value="option.value"
        :selected="option.selected && !defaultSelected"
      >
        {{ option.title }}
      </option>
    </select>
    <span class="icon-container">
      <svg-icon
        :class="'icon-chevron-down'"
        :name="'chevron-down'"
        aria-hidden="true"
        focusable="false"
      />
    </span>
  </div>
</template>

<script>
export default {
  name: 'CustomSelect',
  props: {
    id: {
      type: String,
      required: true
    },
    label: {
      type: String,
      required: true
    },
    disabled: {
      type: Boolean,
      default: undefined
    },
    attr: {
      type: Object,
      default: undefined
    },
    options: {
      type: Array, // {title: 'TestTitle1', value: 'TestValue1'},
      required: true
    },
    selectedLabel: {
      type: String,
      default: undefined
    },
    defaultSelected: {
      type: Boolean,
      default: true
    }

  },
  data () {
    return {

    }
  },
  methods: {
    optionChanged () {
      this.$emit('set-optionChanged')
    }
  }
}
</script>
